export const DEFAULT_EVENT_IMAGE = 'https://images.pexels.com/photos/3376799/pexels-photo-3376799.jpeg';
export const DEFAULT_TICKET_TITLE = 'Standard admission';
export const PERSONAL_INSTITUTION_ID = 300;
export const DEFAULT_FEEDBACK_FORM_ID = 1;
export const LOCK_AFTER_UNSUCCESSFUL_LOGIN_ATTEMPTS = 5;
